export default "__VITE_ASSET__DlHuJGcL__"